import { LayoutService } from '../../services/layout.service';

export abstract class SidenavContent {
  constructor(public layoutService: LayoutService) {}

  closeNav() {
    this.layoutService.closeSideNav();
  }
}
